import { STAGE_ORDER, IMPLEMENTED_STAGES, formatStageLabel } from '../../utils/formatters';

export default function StageProgressBar({ currentStage }) {
  // activeIdx === -1 when currentStage is not a ladder stage (e.g. a deal
  // with status 'denied' / 'suspended'). In that case nothing is active and
  // nothing is marked past — every stage renders as upcoming/reserved.
  const activeIdx = STAGE_ORDER.indexOf(currentStage);

  return (
    <div style={{ display: 'flex', gap: 2, margin: '12px 0' }}>
      {STAGE_ORDER.map((stage, i) => {
        const isActive = stage === currentStage;
        // Reserved = defined for display but not yet reachable by any
        // transition. Reserved styling takes precedence over "past" so these
        // stages never read as completed even when an implemented current
        // stage (e.g. due_diligence) sits later in STAGE_ORDER than them.
        const isReserved = !isActive && !IMPLEMENTED_STAGES.includes(stage);
        const isPast = !isActive && !isReserved && activeIdx > i;

        let barStyle;
        if (isActive) {
          barStyle = { background: 'var(--color-accent)' };
        } else if (isReserved) {
          barStyle = {
            background: 'transparent',
            border: '1px dashed var(--color-border)',
            boxSizing: 'border-box',
          };
        } else if (isPast) {
          barStyle = { background: 'var(--color-success)' };
        } else {
          barStyle = { background: 'var(--color-border)' };
        }

        let labelColor = 'var(--color-text-secondary)';
        if (isActive) labelColor = 'var(--color-accent)';
        else if (isPast) labelColor = 'var(--color-success)';

        return (
          <div key={stage} style={{ flex: 1, minWidth: 0 }}>
            <div style={{
              height: 6,
              borderRadius: 3,
              marginBottom: 4,
              ...barStyle,
            }} />
            <p style={{
              fontSize: 10,
              fontWeight: isActive ? 700 : 400,
              fontStyle: isReserved ? 'italic' : 'normal',
              color: labelColor,
              opacity: isReserved ? 0.55 : 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
              {formatStageLabel(stage)}
            </p>
          </div>
        );
      })}
    </div>
  );
}
